import moment from 'moment/moment';
import 'moment/locale/id';

export const convertChatDateTimeToMoment = (dateTime = '') => {
  if (!dateTime) return null;

  return moment(dateTime).add({ hours: 7 });
};

export const disabledDateAfterToday = (current) => {
  return current > moment();
};
